import React from 'react';
import LoginForm from '../components/auth/LoginForm';
import { Box, IconButton, useTheme } from '@mui/material';
import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material';
import { useThemeMode } from '../contexts/ThemeContext';

const Login: React.FC = () => {
  const theme = useTheme();
  const { isDarkMode, toggleDarkMode } = useThemeMode();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: theme.palette.background.default,
        backgroundImage: isDarkMode
          ? 'linear-gradient(to bottom right, rgba(27, 106, 99, 0.05), rgba(27, 106, 99, 0.15))'
          : 'linear-gradient(to bottom right, rgba(27, 106, 99, 0.05), rgba(27, 106, 99, 0.15))',
        py: { xs: 3, sm: 4 },
        boxSizing: 'border-box',
        overflow: 'auto',
        position: 'relative'
      }}
    >
      {/* Botao de Dark Mode no canto superior direito */}
      <IconButton
        onClick={toggleDarkMode}
        aria-label={isDarkMode ? 'Ativar modo claro' : 'Ativar modo escuro'}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          bgcolor: theme.palette.primary.main,
          color: 'white',
          '&:hover': {
            bgcolor: theme.palette.primary.dark
          }
        }}
      >
        {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>

      <LoginForm />
    </Box>
  );
};

export default Login;
